export const SET_DRAFT = "DIMENSION_TOOL_PANEL/DRAFT/SET";
export const SET_SHOW_DOORS = "DIMENSION_TOOL_PANEL/DRAFT/SET_SHOW_DOORS";
export const DRAG_DIMENSION_VALUE = "DIMENSION_TOOL_PANEL/DRAFT/DRAG_DIMENSION_VALUE";
export const SELECT_ALL_TOGGLE = "DIMENSION_TOOL_PANEL/DRAFT/SELECT_ALL_TOGGLE";
export const TOGGLE_DIMENSION_VALUE = "DIMENSION_TOOL_PANEL/DRAFT/TOGGLE_DIMENSION_VALUE";
export const SORT_ASCENDING = "DIMENSION_TOOL_PANEL/DRAFT/SORT_ASCENDING";
export const SORT_DESCENDING = "DIMENSION_TOOL_PANEL/DRAFT/SORT_DESCENDING";
export const SET_METRICS_FROM_SCHEMA = "DIMENSION_TOOL_PANEL/DRAFT/SET_METRICS_FROM_SCHEMA";
export const SET_SHOW = "DIMENSION_TOOL_PANEL//SET_SHOW";
export const TOGGLE_METRIC = "DIMENSION_TOOL_PANEL/DRAFT/TOGGLE_METRIC";
export const TOGGLE_SWITCH = "DIMENSION_TOOL_PANEL/DRAFT/TOGGLE_SWITCH";
export const MOVE_METRIC = "DIMENSION_TOOL_PANEL/DRAFT/MOVE_METRIC";
export const MOVE_ATTRIBUTE = "DIMENSION_TOOL_PANEL/DRAFT/ATTRIBUTE";
export const TOGGLE_ASSORTMENT_TOTALS = "DIMENSION_TOOL_PANEL/DRAFT/TOGGLE_ASSORTMENT_TOTALS";
export const TOGGLE_ATTRIBUTE_LABEL = "DIMENSION_TOOL_PANEL/DRAFT/TOGGLE_ATTRIBUTE_LABEL";
export const TOGGLE_PLAN_TOTALS = "DIMENSION_TOOL_PANEL/DRAFT/TOGGLE_PLAN_TOTALS";
export const SYNC_RECEIVED_UPDATES_WITH_DIMENSION_PANEL_STATE =
    "DIMENSION_TOOL_PANEL/DRAFT/SYNC_RECEIVED_UPDATES_WITH_DIMENSION_PANEL_STATE";
